import { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import PopupIsca from './PopupIsca'

const IconGift = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 12 20 22 4 22 4 12"/>
    <rect x="2" y="7" width="20" height="5"/>
    <line x1="12" y1="22" x2="12" y2="7"/>
    <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
    <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
  </svg>
)

export default function GiftFloatingButton() {
  const [popupOpen, setPopupOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const shownRef = useRef(false)

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1500)
    return () => clearTimeout(t)
  }, [])

  const showPopup = () => {
    if (shownRef.current) return
    shownRef.current = true
    setPopupOpen(true)
  }

  useEffect(() => {
    if (sessionStorage.getItem('popup_shown')) {
      shownRef.current = true
      return
    }
    const timer = setTimeout(showPopup, 45_000)
    const onExit = (e: MouseEvent) => { if (e.clientY <= 0) showPopup() }
    document.addEventListener('mouseleave', onExit)
    return () => {
      clearTimeout(timer)
      document.removeEventListener('mouseleave', onExit)
    }
  }, [])

  const handleOpen = () => {
    sessionStorage.setItem('popup_shown', '1')
    shownRef.current = true
    setPopupOpen(true)
  }

  const handleClose = () => {
    sessionStorage.setItem('popup_shown', '1')
    setPopupOpen(false)
  }

  return (
    <>
      <AnimatePresence>
        {popupOpen && <PopupIsca key="popup" onClose={handleClose} />}
      </AnimatePresence>

      {visible && (
        <motion.button
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring' }}
          onClick={handleOpen}
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            width: 52,
            height: 52,
            borderRadius: '50%',
            background: 'var(--accent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            zIndex: 40,
            boxShadow: '0 0 0 0 rgba(79,126,247,0.4)',
            animation: 'pulse-gift 2.5s infinite',
          }}
          aria-label="Recursos gratuitos"
        >
          <IconGift />
        </motion.button>
      )}

      <style>{`
        @keyframes pulse-gift {
          0%   { box-shadow: 0 0 0 0 rgba(79,126,247,0.4); }
          70%  { box-shadow: 0 0 0 12px rgba(79,126,247,0); }
          100% { box-shadow: 0 0 0 0 rgba(79,126,247,0); }
        }
      `}</style>
    </>
  )
}
